import { render, staticRenderFns } from "./FoodCourtMerchantOrderStatus.vue?vue&type=template&id=50f1fb9c"
import script from "./FoodCourtMerchantOrderStatus.vue?vue&type=script&lang=js"
export * from "./FoodCourtMerchantOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports